import { Action } from '../../infra/types'
import { OrderSummaryActions } from './orderSummary.actions'
import { OrderSummaryState } from './orderSummary.state'
import { IOrderSummaryState } from './orderSummary.types'

export const OrderSummaryReducer = (
  state: IOrderSummaryState = OrderSummaryState,
  action: Action<any>
): IOrderSummaryState => {
  switch (action.type) {
    case OrderSummaryActions.GET_ORDER_SUMMARY: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          orderSummary: true,
          allOrderListLoader: true
        },
        orderSummaryData: null
      }
    }
    case OrderSummaryActions.SET_ORDER_SUMMARY: {
      return {
        ...state,
        orderSummaryData: action.payload,
        loaders: {
          ...state.loaders,
          orderSummary: true
        }
      }
    }
    case OrderSummaryActions.SET_ORDER_SUMMARY_LIST_ITEMS: {
      return {
        ...state,
        allOrderListData: action.payload,
        loaders: {
          ...state.loaders,
          allOrderListLoader: true
        }
      }
    }
    case OrderSummaryActions.GET_ORDER_GROUP_SUMMARY: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          groupSummary: true
        }
      }
    }
    case OrderSummaryActions.GET_ORDER_GROUP_SUMMARY_SUCCESS: {
      return {
        ...state,
        groupViewData: action.payload,
        loaders: {
          ...state.loaders,
          groupSummary: false
        }
      }
    }
    case OrderSummaryActions.SET_LOADER: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          [action.payload.id]: action.payload.value
        }
      }
    }
    case OrderSummaryActions.SET_SUMMARY_ACTIVE_FILTER: {
      return {
        ...state,
        activeFilter: action.payload
      }
    }
    case OrderSummaryActions.SET_DRAWER: {
      return {
        ...state,
        drawers: {
          ...state.drawers,
          [action.payload.modalName]: action.payload.status
        }
      }
    }
    case OrderSummaryActions.GET_OVERALL_ORDER_GROUP_SUMMARY_SUCCESS: {
      return {
        ...state,
        overallOrderGroupData: {
          ...state.overallOrderGroupData,
          data: action.payload.data,
          page: action.payload.page,
          limit: action.payload.limit,
          totalItems: action.payload.totalItems
        }
      }
    }
    case OrderSummaryActions.GET_OVERALL_ORDER_GROUP_SUMMARY: {
      return {
        ...state,
        overallOrderGroupData: {
          ...state.overallOrderGroupData,
          data: [],
          page: 1,
          totalItems: 0,
          limit: 100
        },
        loaders: {
          ...state.loaders,
          overallGroupSummary: true
        }
      }
    }
    default: {
      return state
    }
  }
}
